import Link from 'next/link'
import React from 'react'

import { Icon } from '@/components/Icon/Icon'
import { usePixieWorldAuthContext } from '@/shared/auth/pixieWorldAuthContext'
import { pxToRem } from '@/shared/styles/themes'
import { faArrowRightFromBracket } from '@fortawesome/pro-regular-svg-icons/faArrowRightFromBracket'
import { faBookmark } from '@fortawesome/pro-regular-svg-icons/faBookmark'
import { faChevronRight } from '@fortawesome/pro-regular-svg-icons/faChevronRight'
import { faUserCircle } from '@fortawesome/pro-solid-svg-icons/faUserCircle'
import { Avatar, Box, Divider, ListItemIcon, ListItemText, MenuItem, MenuList, styled, Typography } from '@mui/material'

export type ProfileDropdownProps = {
  onClose?: () => void
}

export const ProfileDropdown: React.FC<ProfileDropdownProps> = () => {
  const { signOut, profile } = usePixieWorldAuthContext()

  const onSignOut = () => {
    signOut()
    window.location.reload()
  }

  return (
    <StyledMenuList>
      <MenuItem
        disableRipple
        component={Link}
        href={`/profile/${profile?.slug}`}
        sx={{
          paddingTop: pxToRem(12),
          paddingBottom: pxToRem(12),
          paddingLeft: pxToRem(12),
          paddingRight: pxToRem(12),
        }}
      >
        {profile?.profile_picture ? (
          <StyledProfileAvatar alt={profile?.username || ''} src={profile?.profile_picture} />
        ) : (
          <StyledAvatarIcon icon={faUserCircle} />
        )}
        <StyledProfileInfo>
          <StyledUsername variant="body1">{profile?.display_name || profile?.username}</StyledUsername>
          <StyledHandle variant="caption">@{profile?.slug}</StyledHandle>
        </StyledProfileInfo>
        <StyledIcon icon={faChevronRight} />
      </MenuItem>

      <MenuItem disableRipple component={Link} href={'/library'}>
        <ListItemIcon>
          <StyledIcon icon={faBookmark} />
        </ListItemIcon>
        <ListItemText>My Library</ListItemText>
      </MenuItem>

      {/*<MenuItem disableRipple component={Link} href={'/account/edit'}>*/}
      {/*  <ListItemIcon>*/}
      {/*    <StyledIcon icon={faCog} />*/}
      {/*  </ListItemIcon>*/}
      {/*  <ListItemText>Settings</ListItemText>*/}
      {/*</MenuItem>*/}

      <Divider />

      <MenuItem disableRipple onClick={onSignOut}>
        <ListItemIcon>
          <StyledIcon icon={faArrowRightFromBracket} />
        </ListItemIcon>
        <ListItemText>Sign Out</ListItemText>
      </MenuItem>
    </StyledMenuList>
  )
}

const StyledMenuList = styled(MenuList)`
  min-width: calc(100dvw - ${pxToRem(32)});
  padding-bottom: 0;

  ${props => props.theme.breakpoints.up('sm')} {
    min-width: ${pxToRem(260)};
    padding-bottom: 8px;
  }
`

const StyledIcon = styled(Icon)`
  color: ${props => props.theme.palette.text.secondary};
  font-size: ${pxToRem(18)};
`


const StyledProfileAvatar = styled(Avatar)`
  width: ${pxToRem(36)};
  height: ${pxToRem(36)};
  margin-right: ${pxToRem(12)};
`

const StyledAvatarIcon = styled(Icon)`
  width: ${pxToRem(36)};
  height: ${pxToRem(36)};
  margin-right: ${pxToRem(12)};
  color: #bdbdbd;
`

const StyledProfileInfo = styled(Box)`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
`

const StyledUsername = styled(Typography)`
  font-weight: 500;
  line-height: 1.2;
`

const StyledHandle = styled(Typography)`
  color: ${props => props.theme.palette.text.secondary};
`